import { InitiateResponse } from "../common";

export class StatusOverlay {
    private overlayElement: HTMLDivElement;
    private data: InitiateResponse;

    constructor(data: InitiateResponse) {
        const overlay = document.getElementById("status-overlay");
        if (!overlay || !(overlay instanceof HTMLDivElement)) {
            throw new Error("Status overlay not found");
        }
        this.overlayElement = overlay;
        this.data = data;

        this.setMarks(this.marks);
    }
    private get marks() {
        const data = this.data;
        const marks = [];

        marks.push(data.mimeType);
        if (data.hasMetadata) marks.push("M");
        if (data.hasPreview) marks.push("P");
        if (data.hasEnglishSubtitles) marks.push("ES");
        if (data.hasOriginalSubtitles) marks.push("OS");
        if (data.isTranscoded) marks.push("T");
        if (data.isEdited) marks.push("E");
        return marks;
    }

    private setMarks(marks: string[]) {
        const markContent = marks.map((mark) => `${mark}`).join(" - ");
        this.overlayElement.innerText = markContent;
    }
}
